import { T } from 'antd/lib/upload/utils';

export const COLUMN_ANGEL_NUDGE = [
  {
    label: 'Nudge Type',
    stateValue: 'nudgeType',
  },
  {
    label: 'Nudge Name',
    stateValue: 'nudgeName',
    minWidth: 112,
  },
  {
    label: 'Trigger Time/Event Trigger',
    stateValue: 'triggle',
  },
  {
    label: 'Number of Follow-up Nudges',
    stateValue: 'numberOfFollowUpNudges',
  },
  {
    label: 'Status',
    stateValue: 'status',
  },
  {
    label: 'Fallback Action',
    stateValue: 'fallbackAction',
  },
  {
    label: 'Nudge Status',
    stateValue: 'nudgeStatus',
  },
  {
    label: 'Action',
  },
];

export const CHANNEL_DISPLAY = {
  App: 'App',
  WhatsApp: 'WhatsApp',
  Email: 'Email',
};

export const CHANNEL_DISPLAY_COLORS = {
  [CHANNEL_DISPLAY.App]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [CHANNEL_DISPLAY.WhatsApp]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [CHANNEL_DISPLAY.Email]: {
    txt: '#23A6CC',
    background: '#23a6cc29',
  },
};

export const TYPE_MODAL = {
  Edit: 'Edit',
  Create: 'Create',
};

export const ANGEL_NUDGE = {
  ToBeSent: 'To be Sent',
  Failed: 'Failed',
  Sent: 'Sent',
};

export const ANGEL_NUDGE_FALLBACK = {
  DoNothing: 'Do Nothing',
  SentToCSO: 'Send to CSO Team',
  SendAgain: 'Send Nudge Again',
};

export const ANGEL_NUDGE_STATUS = [
  {
    value: 'To be Sent',
    key: 'ToBeSent',
  },
  {
    value: 'Failed',
    key: 'Failed',
  },
  {
    value: 'Sent',
    key: 'Sent',
  },
];

export const ANGEL_NUDGE_STATUS_COLORS = {
  [ANGEL_NUDGE.Sent]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [ANGEL_NUDGE_FALLBACK.SendAgain]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [ANGEL_NUDGE.ToBeSent]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [ANGEL_NUDGE_FALLBACK.DoNothing]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [ANGEL_NUDGE.Failed]: {
    txt: '#DB3D49',
    background: '#db3d4929',
  },
  [ANGEL_NUDGE_FALLBACK.SentToCSO]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
};

export const NUGDE_TYPE = [
  {
    key: 'Rules',
    value: 'Rules (SQL)',
  },
  {
    key: 'Event',
    value: 'Event',
  },
];

export const NUGDE_ACTION = [
  {
    key: 'DoNothing',
    value: 'Do Nothing',
  },
  {
    key: 'SendAgain',
    value: 'Send Nugde Again',
  },
  {
    key: 'SentToCSO',
    value: 'Send to CSO Team',
  },
];

export const NUGDE_FALLBACK_ACTION = [
  {
    key: 'DoNothing',
    value: 'Do Nothing',
  },
  {
    key: 'SentToCSO',
    value: 'Send to CSO Team',
  },
];

export const NUGDE_EVENT_TRIGGLE = [
  {
    key: 'ResultDownload',
    value: 'Results Download - IR Ready',
  },
  {
    key: 'IRReady',
    value: 'Critical Results - IR Ready',
  },
  {
    key: 'ResultDownloadAndIRReady',
    value: 'Previous Day of Screening at 5PM',
  },
];

export const NUDGE_STATUS = {
  Active: 'Active',
  InActive: 'Inactive',
};

export const NUDGE_STATUS_COLORS = {
  [NUDGE_STATUS.InActive]: {
    txt: '#333333',
    background: '#f1f1f1',
  },
  [NUDGE_STATUS.Active]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
};

export const NUDGE_STATUS_OPTIONS = [
  {
    key: 'Active',
    value: 'Active',
  },
  {
    key: 'Inactive',
    value: 'Inactive',
  },
];
